(() => {
  const tracked = new Set();
  const visible = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const sync = el => el.toggleAttribute('data-foil-active', visible.has(el) && !document.hidden && !reduced.matches);
  const size = el => {
    const surface = el.firstElementChild;
    const w = el.clientWidth, h = el.clientHeight, ratio = Number(el.dataset.foilRatio);
    if (!w || !h || !ratio) return;
    let sw = w, sh = h;
    if (el.dataset.foilFit !== 'cover') {
      sw = Math.min(w, h * ratio); sh = sw / ratio;
    }
    const align = el.dataset.foilAlign;
    surface.style.inset = 'auto';
    surface.style.width = sw + 'px'; surface.style.height = sh + 'px';
    surface.style.left = ((w - sw) / 2) + 'px';
    surface.style.top = (align === 'top' ? 0 : align === 'bottom' ? h - sh : (h - sh) / 2) + 'px';
    el.setAttribute('data-foil-ready', '');
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => size(entry.target)));
  const intersect = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
    sync(entry.target);
  }), {threshold: 0});
  const add = root => {
    const elements = root.matches?.('.hgg-foil-overlay') ? [root] : [];
    elements.push(...root.querySelectorAll?.('.hgg-foil-overlay') || []);
    elements.forEach(el => {
      if (tracked.has(el)) return;
      tracked.add(el); size(el); resize.observe(el); intersect.observe(el);
    });
  };
  add(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) add(node); }));
    tracked.forEach(el => {
      if (!el.isConnected) { resize.unobserve(el); intersect.unobserve(el); tracked.delete(el); visible.delete(el); }
    });
  }).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('visibilitychange', () => tracked.forEach(sync));
  reduced.addEventListener('change', () => tracked.forEach(sync));
})();
